import { gql } from '@apollo/client';

export const ALL_WORKSPACE_RESPONDENTS = gql`
  query AllWorkspaceRespondents($input: WorkspaceRespondentFilterInput!) {
    users: allWorkspaceRespondents(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          type {
            id
            name
          }
          cohorts {
            id
            name
            isInstitutionCohort
            isInterventionCohort
            isPeopleCohort
          }
          institutions {
            id
            name
          }
        }
      }
    }
  }
`;
